export function notification(self, type, actionType, name) {
  let message = "";
  let lastMessage = "";
  switch (actionType) {
    case "create":
      message = `Thêm mới ${name}`;
      break;
    case "update":
      message = `Cập nhật ${name}`;
      break;
    case "config":
      message = `Cấu hình ${name}`;
      break;
    case "delete":
      message = `Xoá ${name}`;
      break;
    default:
      break;
  }
  switch (type) {
    case "success":
      lastMessage = "thành công";
      break;
    default:
      lastMessage = "thất bại";
      break;
  }
  self.$notify({
    title: "Thông báo",
    message: message + " " + lastMessage,
    type,
  });
}

export function JSONToFile(obj, filename) {
  const blob = new Blob([JSON.stringify(obj, null, 2)], {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.json`;
  a.click();
  URL.revokeObjectURL(url);
}
